import '../../style/base.css';
import '../../info/index.css';
import '../../icon/index.css';
import '../../cell/index.css';
import '../../field/index.css';
import '../index.css';


//////////////////
// WEBPACK FOOTER
// ./~/vant/es/search/style/index.js
// module id = 172
// module chunks = 0